import {action, configure, makeObservable, observable} from 'mobx';
import {router} from "@inertiajs/react";
import {route} from "ziggy-js";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";

export default class ProfileStore {
    // //Начальное состояние модалки
    // @observable bonusesModal = false;
    // @observable serverError = '';
    // @observable serverOk = '';
    // //Отзывы
    // @observable reviews = [];
    // reviewsCount = 5;
    // @observable reviewsOneCount = 0;
    // @observable reviewsTwoCount = 0;
    // @observable reviewsThreeCount = 0;
    // @observable reviewsFourCount = 0;
    // @observable reviewsFiveCount = 0;
    // //Модалка "Задать вопрос"
    // @observable questionOpen = false;
    // // //Успешное добавление в лист ожидания
    // // @observable successAddWaitListOpen = false;
    // @observable serverOkDeliveryAddress = '';
    // @observable serverErrorDeliveryAddress = '';
    // @observable serverTextScan = '';
    // @observable serverErrorScan = '';
    // @observable errorScan = '';
    // //Принимаем ошибки сервера форма "Задать вопрос"
    // @observable serverErrorSendRequest = '';
    // //Чек бокс - Напоминание о товарах в корзине
    // @observable info_basket = true;
    // //Чек бокс - Скидки, акции и новые коллекции
    // @observable action_stocks_assortment = false;
    // //Чек бокс - Push уведомления
    // @observable push_notifications = true;
    // //Статус - Лист ожидания
    // @observable waitingServerTitle = '';
    // @observable waitingServerMessage = '';
    // @observable statusWaitingList = '';
    // //Чек бокс Бонусная карта, принять участие, по умолчанию всегда стоит
    // @observable checkedPersonal = true;
    // //Успешная или не успешная отправка формы "Задать вопрос"
    // @observable questionFlag = false;
    // //Успешное или не успешное получение данных о заданных вопросах пользователя
    // @observable resultAnswerFlag = false;
    // //Дополнительный класс для формы во время отправки
    // @observable formLoad = '';
    // @observable formLoadPassportProfile = '';
    // @observable formLoadWaitList = '';
    // @observable formLoadDeliveryAddress = '';
    // @observable formLoadScan = '';
    // @observable formLoadResetPassword = '';
    // @observable formLoadTakePartProgram = '';
    // @observable serverResetPasswordOk = '';
    // @observable serverPassportProfileOk = '';
    // @observable serverResetPasswordError = '';
    // @observable loadRepeatOrder = '';
    // @observable files = [];
    // @observable scanFlag = true;
    // // // Лоадеры
    // // @observable loaderAddWaitList = '';
    // // Лист ожидания пользователя
    // @observable usersWaitList = [];
    // // Бонусная программа
    // @observable dataDiscountCard = [];
    // @observable bonusesModalInfo = [];
    // @observable getDiscountCardLoader = false;
    // @observable productsWithoutReviews = [];
    // @observable ratingAVG = 0;
    // @observable dataProvider = [];
    // @observable result = [];
    // @observable reviewsResult = [];

    constructor(rootStore) {
        makeObservable(this)
        configure({
            enforceActions: "never",
        })
        this.rootStore = rootStore;
    }

    // @action getSizeWaitList = async (id, size = '') => {
    //     this.loaderAddWaitList = 'load';
    //
    //     const values = {
    //         id_product: id,
    //         size: '',
    //     };
    //
    //     if (size === '') {
    //         const response = await axios.post('/get_size_wait_list', {id: id});
    //
    //         try {
    //             const {success} = response.data;
    //
    //             if (success.status) {
    //                 if (success.data.length === 0) {
    //                     await this.addWaitList(values);
    //                     this.loaderAddWaitList = '';
    //                 } else {
    //                     this.rootStore.productDetailStore.productData = success.data;
    //                     this.rootStore.productDetailStore.openModalNotSize(id);
    //                     this.loaderAddWaitList = '';
    //                 }
    //             } else {
    //                 this.loaderAddWaitList = '';
    //             }
    //         } catch (e) {
    //             console.log('e', e);
    //         }
    //     } else {
    //         values.size = size;
    //         await this.addWaitList(values);
    //         this.loaderAddWaitList = '';
    //     }
    // }

    // /**
    //  * Добавляем в лист ожидания
    //  * @param values
    //  * @returns {Promise<void>}
    //  */
    // @action addWaitList = async (values) => {
    //     try {
    //         this.formLoadWaitList = 'load';
    //         const response = await axios.post('/add_wait_list', values);
    //
    //         const {success} = response.data;
    //         const {status = false, data = [], errors = []} = success;
    //
    //         if (status) {
    //             this.waitingServerTitle = data.title;
    //             this.waitingServerMessage = data.message;
    //         } else {
    //             this.waitingServerTitle = errors.title;
    //             this.waitingServerMessage = errors.errorMessage[0];
    //         }
    //
    //         this.formLoadWaitList = '';
    //         this.openSuccessAddWaitList();
    //     } catch (e) {
    //         this.formLoadWaitList = '';
    //         this.waitingServerTitle = 'Внимание';
    //         this.waitingServerMessage = 'Не удалось добавить украшение в лист ожидания!';
    //         this.openSuccessAddWaitList();
    //     }
    // };

    // /**
    //  * Открытие модалки "Успешное добавление в лист ожидания"
    //  */
    // @action openSuccessAddWaitList() {
    //     this.rootStore.productDetailStore.closeModalNotSize();
    //     this.successAddWaitListOpen = true;
    // }

    // /**
    //  * Закрытие модалки "Успешное добавление в лист ожидания"
    //  */
    // @action closeSuccessAddWaitList() {
    //     this.waitingServerTitle = '';
    //     this.waitingServerMessage = '';
    //     this.successAddWaitListOpen = false;
    // }

    /**
     * Повтор заказа
     * @param id
     * @returns {boolean}
     */
    repeatOrder = (id = null) => {
        try {
            router.post(route('repeatOrder'), {id: id}, {
                onSuccess: (page) => {
                    this.loadRepeatOrder = '';
                    this.rootStore.modalStore.successRepeatOrderServerMsg = page.props.success.message;
                    this.rootStore.modalStore.successRepeatOrderToggle = true;
                },
                onError: (errors) => {
                    this.loadRepeatOrder = '';
                },
            });
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Отмена заказа пользователем
     * @param id
     */
    cancelOrder = (id) => {
        try {
            router.post(route('cancelOrder'), {id: id}, {
                onSuccess: (page) => {
                    reachGoalYM('account_cancel_order');
                    reachGoalGA('account_cancel_order');
                },
                onError: (errors) => {
                    if (errors?.errorMessage) {
                        this.rootStore.basketStore.errorOrderMessage = errors.errorMessage;
                        this.rootStore.basketStore.openDialogBasket();
                    }
                },
            });
        } catch (e) {
            console.log('e', e);
        }
    }
}
